<script setup>
  defineProps({
    title: { type: String, default: undefined },
    divider: Boolean,
  });
</script>

<template>
  <div>
    <div class="d-flex justify-space-between title-container">
      <h1 class="text-h4 text-h5 text-center">
        {{ title }}
      </h1>
      <slot />
    </div>
    <v-divider v-if="divider" class="my-4" />
  </div>
</template>

<style scoped>
  .title-container {
    margin-bottom: 20px;
  }

  .calendar-btn,
  .title-text {
    align-self: flex-end;
  }

  @media screen and (max-width: 500px) {
    .calendar-btn,
    .title-text {
      align-self: center;
    }

    .title-container {
      flex-direction: column;
    }
  }
</style>
